/**
 * SURVEY-GENERATE-QRCODE
 * Generate specific qrcode for the survey
 */

import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import Modal from "@/components/modal"
import { useEffect, useState } from "react"
import { STATUS_LOADED, STATUS_LOADING } from "@/redux/_status.types"
import PageLoader from "@/components/page-loader"
import { SurveyState } from "@/redux/survey.types"
import { store } from ".."
import { generateForSurvey } from "@/redux/_qrcode.actions"
import Link from "@/components/link"
import env from "@/env"

interface StateProps extends WithTranslation {
  survey: SurveyState
}

interface OwnProps {
  onClose: Function
}

type Props = StateProps & OwnProps

function SurveyGenerateQrcodeModal(props: Props) {
  const { t } = props

  const [isLoading, setIsLoading] = useState(true)
  const [generatedQrCode, setGeneratedQrCode] = useState("")

  useEffect(() => {
    loadQrCode()

    async function loadQrCode() {
      const response: any = await store.dispatch(generateForSurvey(props.survey.active.id))
      setIsLoading(false)
      setGeneratedQrCode(response)
    }
  }, [])

  return (
    <Modal title={t("survey_letter_generate_one")} isCloseButtonVisible onClose={() => props.onClose()}>
      <PageLoader status={isLoading ? STATUS_LOADING : STATUS_LOADED}>
        <div>
          <div className="flex">
            <img src={generatedQrCode} alt="qrcode-survey" width="120" height="120" />
            <div>
              <p>
                <b>{t("survey_letter_generate_specific")}</b>
              </p>
              <Link
                onClick={() => window.open(env.REACT_APP_URL_QUICKVOTE + "/survey/" + props.survey.active.id, "_blank")}
                isWithoutMargin>
                {env.REACT_APP_URL_QUICKVOTE + "/survey/" + props.survey.active.id}
              </Link>
            </div>
          </div>
          <div className="flex">
            <img src={require("@/assets/qrcode-qv.png")} alt="qrcode-qv" width="120" height="120" />
            <div>
              <p>
                <b>{t("survey_letter_generate_generic")}</b>
              </p>
              <Link onClick={() => window.open(env.REACT_APP_URL_QUICKVOTE, "_blank")} isWithoutMargin>
                {env.REACT_APP_URL_QUICKVOTE}
              </Link>
            </div>
          </div>
        </div>
      </PageLoader>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  survey: state.survey
})

export default connect(mapStateToProps)(withTranslation()(SurveyGenerateQrcodeModal))
